import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import StillRacing from "./StillRacing";
import EntrantDetails from "./EntrantDetails";

export default function StillRacingApp({ id }) {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={`/events/${id}/still_racing`} element={<StillRacing id={id} />} />
        <Route path="entrants/:entrantId" element={<EntrantDetails eventId={id} />} />
      </Routes>
    </BrowserRouter>
  );
}
